const OrganizationIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M14.1875 10H12.5625V7.625C12.5625 7.55625 12.5063 7.5 12.4375 7.5H8.5625V6H10.25C10.3875 6 10.5 5.8875 10.5 5.75V1.25C10.5 1.1125 10.3875 1 10.25 1H5.75C5.6125 1 5.5 1.1125 5.5 1.25V5.75C5.5 5.8875 5.6125 6 5.75 6H7.4375V7.5H3.5625C3.49375 7.5 3.4375 7.55625 3.4375 7.625V10H1.8125C1.675 10 1.5625 10.1125 1.5625 10.25V14.75C1.5625 14.8875 1.675 15 1.8125 15H6.3125C6.45 15 6.5625 14.8875 6.5625 14.75V10.25C6.5625 10.1125 6.45 10 6.3125 10H4.5625V8.625H11.4375V10H9.6875C9.55 10 9.4375 10.1125 9.4375 10.25V14.75C9.4375 14.8875 9.55 15 9.6875 15H14.1875C14.325 15 14.4375 14.8875 14.4375 14.75V10.25C14.4375 10.1125 14.325 10 14.1875 10ZM5.375 11.1875V13.8125H2.75V11.1875H5.375ZM6.6875 4.8125V2.1875H9.3125V4.8125H6.6875ZM13.25 13.8125H10.625V11.1875H13.25V13.8125Z' />
  </svg>
);

export default OrganizationIcon;
